
    // this file was auto generated by python script
    import Settings from './Settings';
    export default Settings;
    